<div class="icon-img">
  <div
  [style.webkit-mask-image]="'url(' + fullImgUrl + ')'"
  [style.mask-image]="'url(' + fullImgUrl + ')'"
  [style.background]="color"></div>
</div>
